export function setNotifications(state, payload) {
  state.all = payload;
}
